import { clarksonsBrokerHeading } from './clarksonsBrokerHeading';

export const clarksonsBrokerHeadingForOrders = {
    ...clarksonsBrokerHeading,
    headerTooltip: 'Clarksons Internal Broker point contact for the order',
};
